const { Pixel } = require('@flowio/pixel');

let pixel;

function init(options) {
  pixel = new Pixel(options);
  return pixel;
}

function getPixel() {
  return pixel;
}

module.exports = {
  init,
  getPixel,
};



// WEBPACK FOOTER //
// ./static/js/v0/utilities/pixel.js